<template>
  <div id="form" class="content">
      <h1>Ajout d'un cadeau</h1>
      <p>
        <label for="label">Désignation *</label>
        <input v-model="wish.label.value" v-bind:class="{ 'text-danger': wish.label.hasError }">
      </p>
      <p>
        <label for="asin">ASIN</label>
        <span class="asin">
          <input class="asin" v-model="wish.asin">
          <button class="asin" v-on:click="search()">ok</button>
        </span>
      </p>
      <p>
        <label for="link">Lien</label>
        <input v-model="wish.link">
      </p>
      <p>
        <label for="picture">Url de l'image</label>
        <input v-model="wish.picture">
      </p>
      <p>
        <label for="price">Prix *</label>
        <input v-model="wish.price.value" v-bind:class="{ 'text-danger': wish.price.hasError }">
      </p>
      <p>
        <label for="description">Description</label>
        <textarea v-model="wish.description"></textarea>
      </p>
      <p>
        <label for="description">Taille</label>
        <input type="text" v-model="wish.size">
      </p>
      <p>
        <label for="favorite">Favori</label>
        <input type="checkbox" v-model="wish.favorite">
      </p>
      <p>
          <a v-on:click="add()"><span class="fa fa-floppy-o red ico"></span> Enregistrer</a>
          <a v-on:click="undo()"><span class="fa fa-undo red ico" ></span> Annuler</a>
      </p>

      <Wish class="wish" v-bind:wish="w"></Wish>
  </div>
</template>

<script>

import Wish from './Wish'
//var numeral = require("numeral");

export default {
  methods: {
      search() {
        if(typeof this.wish.asin !== 'undefined' ) {

          this.$api.byAsin(this.wish.asin, this, function(component, data){
              console.log(data);

              let item = data["ItemsResult"]["Items"][0]
              component.wish.link = item.DetailPageURL
              //this.label.value = item.ItemInfo.Title.DisplayValue
              component.wish.picture = item.Images.Primary.Large.URL
              component.wish.price.value = item.Offers.Summaries[0].LowestPrice.Amount
              component.wish.description = item.ItemInfo.Features.DisplayValues.join(". ");
          })
        }
      },
      undo(){
        this.$router.push({ path: "/list/" + this.$oauth.getCurrentUser() })
      },
      add() {       
        let error = false
        this.wish.label.hasError = false
        if(this.wish.label.value === '' ) {
            this.wish.label.hasError = true
            error = true
        }
        this.wish.price.hasError = false
        if(this.wish.price.value === '' ) {
            this.wish.price.hasError = true
            error = true
        }

        if(this.wish.favorite == "true" || this.wish.favorite == true){
          this.wish.favorite = true
        }else{ 
          this.wish.favorite = false
        }
        this.wish.priority = parseInt(this.wish.priority)

        if(!error){
            /*
            PUT /wishies/{id} { label:, price: }
            */
            var id = this.wish.id
            if(id == undefined | id == '') {
              id = this.$uuid.v4()
            }
            var wish = {
                label: this.wish.label.value,
                price: this.wish.price.value,
                description: this.wish.description,
                link: this.wish.link,
                picture: this.wish.picture,
                size: this.wish.size,
                priority: this.wish.priority,
                favorite: this.wish.favorite,
            }
            let impersonate = undefined
            if(this.$route.params.owner !== undefined){
              impersonate = this.$route.params.owner
            } 
            this.$api.upsert(id, wish, impersonate, this, function(component, returnUser){
                component.$router.push({ path: "/list/" + returnUser })
            })
        }
      }
  },
  mounted () {    
    if (localStorage.getItem('wish_edit')) {
      console.log("loading")
      try {
        this.wish = JSON.parse(localStorage.getItem('wish_edit'));
        localStorage.removeItem('wish_edit')
      } catch(e) {
        console.log(e)
        localStorage.removeItem('wish_edit')
      }
    }
  },
  data() {
    return {
      wish: {
        id: "",
        asin: "",
        label: {
            value: "",
            hasError: false,
        },
        picture: "",
        description: "",
        link: "",
        price: {
            value: "",
            hasError: false,
        },
        size: "",
        priority: 100,
        favorite: false
      }
    }
  },
  computed: {
    priceInCents: function(){
      console.log(this.wish.price.value)
      return Number(this.wish.price.value.toString().replace('€', '').trim()) * 100
      //return numeral((this.price.value + "").replace('€', ''))*100
    },
    w: function(){
      return {
        label: this.wish.label.value,
        price: this.priceInCents,
        picture: this.wish.picture,
        favorite: this.wish.favorite
      }
    }
  },
components: {Wish}
}
</script>

<style scoped>
@media only screen and (max-width: 600px) {
    #form { width: 100% }
    #form img {width: 100%;}
}

@media only screen and (min-width: 601px) {
    #form { width: 600px }
    .wish {margin-left: 20%;}
}

.ico {
  font-size: 1em;
  margin: 0 0 0 15px;
}

p { width: 100%; clear:both; margin-bottom: 10px; min-height: 1em;}
label { width: 29%; float: left; }
input { width: 69%; float: right; }
textarea { width: 69%; float: right; height: 150px; margin-bottom: 10px;}

span.asin { width: 70%; float: right; }
input.asin {
  width: 87%;
  float: left;
  margin-left: -2px;
}
button.asin {
  width: 10%;
  float: right;
}

.text-danger {
    border: thin solid red;
}
</style>